export const email = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i;
export const notificationIconTag = /(<span class="notification-icon\b[^>]*>)[^<>]*(<\/span>)/gi;
